import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from './../../common/icon/icon.module';
import { RadioFormGroupComponent, RadioGroupItem } from './radio-form-group.component';

@NgModule({
  declarations: [RadioFormGroupComponent],
  exports: [RadioFormGroupComponent],
  imports: [CommonModule, IconModule],
})
export class RadioFormGroupModule {}

export { RadioGroupItem };
export { RadioFormGroupComponent } from './radio-form-group.component';
